/*********************** Custom JS for Boost AI Search & Discovery  ************************/
setTimeout(function () {
  $('.boost-sd__filter-option .boost-sd__filter-option-label button').click();
}, 2500);


const updateProductItem = (componentRegistry) => {
  componentRegistry.useComponentPlugin('ProductItem', {
    name: 'Add SKU and specsheet to product card',
    enabled: true,
    apply: () => ({
      afterRender(element) {
        try {
          let productData =
            element.getParams()?.props?.product ||
            element.getParams()?.props?.productData ||
            element.getParams()?.props?.data;
              let productItem = document.querySelector('[data-product-id="' + productData.id + '"]');
                if (productData.tags && (productData.tags.includes("banner")||productData.tags.includes("remove")) ) {
            
                // Select the "Quick view" button using the correct selector
                let button = productItem.querySelector('.boost-sd__product-item .boost-sd__btn-quick-view');
                if (button) {
                    console.log('Removing Quick View button for product ID:', productData.id);
                    button.remove();  // Remove the button
                } 
               //let productLinks = productItem.querySelectorAll('.boost-sd__product-link');
              // if (productLinks.length > 0) {
              //     productLinks.forEach(link => {
              //         link.href = "/pages/bra-fitting-guide"; // Set new href
              //     });
              // }
                      // Remove the price element
                  
                  let priceElement = productItem.querySelector('.boost-sd__product-price');
                  if (priceElement && productData.tags.includes("banner")) {
                      priceElement.remove();
                  }
            } 
                if (productData.tags && productData.tags.includes("video")) {
              // Remove the price element
                  let priceElement = productItem.querySelector('.boost-sd__product-price');
                  if (priceElement) {
                      priceElement.remove();
                  }
                  // Remove the product title element
                  let titleElement = productItem.querySelector('.boost-sd__product-title');
                  if (titleElement) {
                  titleElement.remove();
    }
          }

             if (!productItem) return;

          const media = productData.media.find(e => e.mediaContentType == "VIDEO");
          if (media) {
            const videoUrl = media.sources[0].url;
            let videoHTML = `<video class="boost-custom-media" width="auto" height="auto" autoplay loop muted
                              controlslist="nodownload" poster="${productData.images_info[0].src}" 
                              data-video-type="mp4" 
                              data-video-style="muted">
                                <source src="${videoUrl}" type="video/mp4">
                                <source src="${videoUrl}" type="video/ogg">
                                Your browser does not support the video tag.
                              </video> `;
            if (!productItem.querySelector('.boost-custom-media')) {
              productItem.querySelector('.boost-sd__product-image').insertAdjacentHTML("afterbegin", videoHTML);
            }
          }

        } catch (e) {}
        
      },
    }),
  });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem]);
// document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
// });

setTimeout(function () {
  // Select all elements with the specified classes
  const productLinksImages = document.querySelectorAll('.boost-sd__product-link-image');
  const productLinks = document.querySelectorAll('.boost-sd__product-link');

  // Merge both NodeLists into a single array
  const allProductLinks = [...productLinksImages, ...productLinks];

  console.log("allProductLinks", allProductLinks);

  // Iterate over each link and update its href attribute
  allProductLinks.forEach(link => {
    // Get the current href value
    let href = link.getAttribute('href');
    
    // Check if the href contains the specific ending we want to modify
    if (href && href.includes('-1')) {
      // Replace '-1' with nothing to remove it
      const updatedHref = href.replace('-1', '');
      
      // Update the link's href attribute with the new value
      link.setAttribute('href', updatedHref);
    }
  });
}, 2500);




